/* i18n */
import i18n from '@/assets/setups/i18n'

const emptyObjectConstructor = () => {
	return {
		toastType: '',
		text: '',
		buttons: []
	}
}

/**
@message {string} - string to display in sucess toast
@returns {object} returns an object with info needed for a toast of error type:
	toastType {string} - 'success'
	text {string} - text to display on toast
	buttons {array} - emptyArray
*/
const sucessObjectConstrutor = (message) => {
	return {
		toastType: 'success',
		text: message,
		buttons: []
	}
}

/**
@message {string} - string to display in sucess toast
@returns {object} returns an object with info needed for a toast of error type:
	toastType {string} - 'warning'
	text {string} - text to display on toast
	buttons {array} - emptyArray
*/
const warningObjectConstrutor = (message) => {
	return {
		toastType: 'warning',
		text: message,
		buttons: []
	}
}

/**
@data {object} - error object response from mdw or from catch
	errorLevel {string} - error code from mdw (opcional)
	message {string, array} - text/list of texts to display on toast
	dismissToastBtnText {string} - custom text for button that triggers dismissAction
@retryFn {function} - function to be called if retry button is clicked
@stepBackFn {function} - function to be called if resolve button is clicked
@returns {object} returns an object with info needed for a toast of error type:
	toastType {string} - type of toast, used in toast for colors and some behaviors
	text {string} - text to display on toast
	buttons {array} - array of buttons
*/
const errorObjectConstructor = (data, retryFn, stepBackFn) => {
	if (!data) {
		return {
			toastType: 'negative',
			text: i18n.global.t('genericErrorMessage'),
			buttons: [{ text: i18n.global.t('commonButtons.ignore') }]
		}
	}

	const buttons = [{ text: data.dismissToastBtnText || i18n.global.t('commonButtons.ignore') }]

	if ((retryFn || (stepBackFn && isStepBackBehaviour(data.code))) && !onlyDismissButton(data.code)) {
        buttons.push({
            id: 'retryButton',
			text: data.code ? errorTextBtnMapper(data.code, data) : i18n.global.t('commonButtons.tryAgain'),
			callbackAction: (isStepBackBehaviour(data.code) || data.invalidParametersErrorMessageList) && stepBackFn ? stepBackFn : retryFn,
			errorCode: data.code
		})
	}

    /* Toast text construct */
    let message = data && data.message ? data.message : i18n.global.t('genericErrorMessage')

    if (data && data.invalidParametersErrorMessageList && data.invalidParametersErrorMessageList.length) {
        message = data.invalidParametersErrorMessageList.map(obj => {
            return obj.errorMessage?.length ? obj.errorMessage : obj.errorCode
        }).join(' ')
    }

	return {
		toastType: 'negative',
		text: message,
		buttons: buttons
	}
}

const errorTextBtnMapper = (errorCode, data) => {
	if (data.invalidParametersErrorMessageList) return i18n.global.t('commonButtons.resolve')

    switch (errorCode) {
		case 'wrong_challenge':
        case 'SAF_WRONG_TOKEN_REPLY':
			return i18n.global.t('commonButtons.newCode')
		case 'insufficient_funds':
		case 'natures_do_not_match':
        case 'INVALID_PHONE_NUMBER':
        case 'destination_account_same_as_origin':
        case 'SPS_GBM5382-Mensagem recusada: 027-Referência inválida':
		case 'proposal_recoverable_error':
		case 'international_transfer_min_amount_required':
		case 'invalid_destination_iban_same_bank':
		case 'end_date_for_recurring_transfer_is_not_a_working_day':
		case 'international_beneficiary_invalid_phone_number':
		case 'invalid_name_each_name_at_least_2_chars':
        case 'insufficient_funds_for_batch_payment_submission':
			return i18n.global.t('commonButtons.resolve')
        default:
            return i18n.global.t('commonButtons.tryAgain')
	}
}

const isStepBackBehaviour = (errorCode) => {
    switch (errorCode) {
        case 'insufficient_funds':
		case 'natures_do_not_match':
        case 'INVALID_PHONE_NUMBER':
        case 'destination_account_same_as_origin':
        case 'SPS_GBM5382-Mensagem recusada: 027-Referência inválida':
		case 'international_transfer_min_amount_required':
		case 'international_beneficiary_invalid_phone_number':
		case 'invalid_name_each_name_at_least_2_chars':
        case 'insufficient_funds_for_batch_payment_submission':
            return true
		case 'wrong_challenge':
        case 'SAF_WRONG_TOKEN_REPLY':
        default:
            return false
	}
}

const onlyDismissButton = (errorCode) => {
    switch (errorCode) {
        case 'max_bookings_reached':
            return true
        default:
            return false
	}
}

export {
	emptyObjectConstructor,
	sucessObjectConstrutor,
	warningObjectConstrutor,
	errorObjectConstructor
}
